exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mbj-archi_content{color:#333;line-height:25px}.mbj-archi_content table div,.mbj-archi_content table p{text-indent:.2em;word-break:break-all}", ""]);

